export default function menuPages() {
    const allcolum = document.querySelectorAll('.column');
    const deskColum = document.querySelectorAll('.deskColumn')
    const columArr = Array.from(allcolum);
    const acesso = columArr[0];
    const energia = columArr[1];
    const bemEstar = columArr[2];
    const btnBemEstar = document.querySelector('.bem_btn');
    const btnEnergia = document.querySelector('.energia_btn');
    const btnAcesso = document.querySelector('.acesso_btn');
    const btn = document.getElementById('btnMobilePages');
    const menuOpen = document.querySelector('.Menu-Mobile-Only');
    const menuOpenDesk = document.querySelector('.dropdownDesk');
    const menuOpenBtn = document.querySelector('.dropbaixo');
    const linkInside = document.querySelectorAll('.link-inside');
    const boxInside = document.querySelectorAll('.box_inside-menu');
    const line = document.getElementById('line');
    const btnAll = document.querySelectorAll('.btn-back');
    const navLink = document.querySelectorAll('.order-mobile-3')
    const btnArr = Array.from(btnAll);
    const acessoBack = btnArr[0];
    const energiaBack = btnArr[1];
    const bemBack = btnArr[2];
    const dropBtn = document.querySelector('.dropbtn');
    const btnCentral = document.querySelector('.btn-central');
    const mobileCentral = document.querySelector('.mobile_central');
    const centralBack = document.querySelector('.central-back');
    const instituMobile = document.querySelector('.institucional_mobile');
    const instituBack = document.querySelector('.institu-back');
    const btnInstitu = document.querySelector('.btn-institu');
    acessoBack.addEventListener('click', acessoVoltar);
    energiaBack.addEventListener('click', energiaVoltar);
    bemBack.addEventListener('click', bemVoltar);
    btnAcesso.addEventListener('click', acessoShow);
    btnEnergia.addEventListener('click', energiaShow);
    btnBemEstar.addEventListener('click', bemShow);
    btn.addEventListener('click', toggleMenu);
    btnCentral.addEventListener('click', centralMobile);
    centralBack.addEventListener('click', backCentral);
    btnInstitu.addEventListener('click', instituActive);
    instituBack.addEventListener('click', instituOff);
    const backLink = document.querySelectorAll('.backLink');
    const backLinkArr = Array.from(backLink);


    function ativar(target){
      target.forEach((e)=>{
        e.classList.add('active')
      });
    }
    function ativarOff(target){
      target.forEach((e)=>{
        e.classList.remove('active')
      });
    }
    function addActive(el){
      el.classList.add('active')
    }
    function removeActive(el){
      el.classList.remove('active')
    }
    function centralMobile(){
      addActive(mobileCentral);
    }
    function backCentral(){
      removeActive(mobileCentral);
    }
    function instituActive(){
      addActive(instituMobile);
    }
    function instituOff(){
      removeActive(instituMobile);
    }
    function toggleMenu(){
      const menuWrap = document.querySelector('.menu_wrap');
      const logo = document.getElementById('topo');
      logo.classList.toggle('active');
      menuWrap.classList.toggle('active');
      btn.classList.toggle('active');
    }
    function energiaShow(){
      bemEstar.style.cssText = 'display:none';
      acesso.style.cssText = 'display:none';
      energia.style.cssText = 'display:block';
      line.classList.add('active');
      dropBtn.classList.add('active');
      ativar(navLink);
    }
    function energiaVoltar(){
      line.classList.remove('active');
      dropBtn.classList.remove('active');
      ativarOff(navLink);
    }
    function acessoShow(){
      bemEstar.style.cssText = 'display:none';
      energia.style.cssText = 'display:none';
      acesso.style.cssText = 'display:block'
      line.classList.add('active');
      dropBtn.classList.add('active');
      ativar(navLink);
    }
    function acessoVoltar(){
      line.classList.remove('active');
      dropBtn.classList.remove('active');
      ativarOff(navLink);
    }
    function bemShow(){
      acesso.style.cssText = 'display:none';
      energia.style.cssText = 'display:none';
      bemEstar.style.cssText = 'display:block'
      line.classList.add('active');
      dropBtn.classList.add('active');
      ativar(navLink);
    }
    function bemVoltar(){
      line.classList.remove('active');
      dropBtn.classList.remove('active');
      ativarOff(navLink);
    }
    function openMenu(){
      if (window.matchMedia("(max-width: 1180px)").matches){
        for (let arrUse = 0; arrUse < arrInside.length; arrUse++){
          arrInside[arrUse].addEventListener('click', ()=>{
            // arrBox.forEach((element) =>{
            //     if (element.classList.contains('active')) {
            //       element.classList.remove('active')
            //     }
            // })
            arrBox[arrUse].classList.add('active')
          })
        }
        for (let arrLink = 0; arrLink <  backLinkArr.length; arrLink++){
          backLinkArr[arrLink].addEventListener('click', ()=>{
            backLinkArr[arrLink].parentElement.classList.remove('active');
         })
       }
      } else{
        menuOpenDesk.classList.toggle('active');
        menuOpenBtn.classList.toggle('active');
        for (let arrUse = 0; arrUse < arrInside.length; arrUse++){
          arrInside[arrUse].addEventListener('mouseover', ()=>{
            arrBox.forEach((element) =>{
                if (element.classList.contains('active')) {
                  element.classList.remove('active')
                }
            })
            arrBox[arrUse].classList.toggle('active')
          })
        }
      }
    }


    //DESK
    menuOpenBtn.addEventListener('click', openMenu)

    const deskColumArr = Array.from(deskColum);
    const energyEvery = deskColumArr[1];
    const bemEvery = deskColumArr[2];


    deskColumArr[0].children[1].addEventListener('mouseover', () =>{
      deskColumArr[0].children[1].style.cssText = 'display: block';
      deskColumArr[0].children[0].style.cssText = 'opacity: 1';
      energyEvery.children[0].style.cssText = 'opacity: .6';
      bemEvery.children[0].style.cssText = 'opacity: .6';
      energyEvery.children[1].style.cssText = 'display: none';
      bemEvery.children[1].style.cssText = 'display: none';
    })
    deskColumArr[0].children[1].addEventListener('mouseleave', () =>{
      deskColumArr[0].children[1].style.cssText = 'display: block';
      energyEvery.children[1].style.cssText = 'display: block';
      bemEvery.children[1].style.cssText = 'display: block';
      energyEvery.children[0].style.cssText = 'opacity: 1';
      bemEvery.children[0].style.cssText = 'opacity: 1';
      arrBox.forEach((element) =>{
        if (element.classList.contains('active')) {
          element.classList.remove('active')
        }
    })
    })
    energyEvery.children[1].addEventListener('mouseover', () =>{
      energyEvery.children[1].style.cssText = 'display:block'
      energyEvery.children[0].style.cssText = 'opacity: 1'
      deskColumArr[0].children[0].style.cssText = 'opacity: .6';
      bemEvery.children[0].style.cssText = 'opacity: .6';
      deskColumArr[0].children[1].style.cssText = 'display: none';
      bemEvery.children[1].style.cssText = 'display: none';
    })
    energyEvery.children[1].addEventListener('mouseleave', () =>{
      deskColumArr[0].children[1].style.cssText = 'display: block';
      energyEvery.children[1].style.cssText = 'display: block';
      bemEvery.children[1].style.cssText = 'display: block';
      deskColumArr[0].children[0].style.cssText = 'opacity: 1';
      bemEvery.children[0].style.cssText = 'opacity: 1';
      arrBox.forEach((element) =>{
        if (element.classList.contains('active')) {
          element.classList.remove('active')
        }
    })
    })
    bemEvery.children[1].addEventListener('mouseover', () =>{
      bemEvery.children[1].style.cssText = 'display:block'
      bemEvery.children[0].style.cssText = 'opacity: 1'
      deskColumArr[0].children[0].style.cssText = 'opacity: .6';
      energyEvery.children[0].style.cssText = 'opacity: .6';
      deskColumArr[0].children[1].style.cssText = 'display: none';
      energyEvery.children[1].style.cssText = 'display: none';
    })
    bemEvery.children[1].addEventListener('mouseleave', () =>{
      deskColumArr[0].children[1].style.cssText = 'display: block';
      energyEvery.children[1].style.cssText = 'display: block';
      bemEvery.children[1].style.cssText = 'display: block';
      deskColumArr[0].children[0].style.cssText = 'opacity: 1';
      energyEvery.children[0].style.cssText = 'opacity: 1';
      arrBox.forEach((element) =>{
        if (element.classList.contains('active')) {
          element.classList.remove('active')
        }
    })
    })

    const arrInside = Array.from(linkInside);
    const arrBox = Array.from(boxInside);



  }

  menuPages();
